module.exports = __webpack_public_path__ + "img/right_building_designs.f2149dfc.png";